import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import RichText from '../RichText'

export const Container = styled.div``

export const Toggle = styled.button`
  position: relative;
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  justify-items: start;
  cursor: pointer;
  background: unset;
  color: ${({ theme }) => theme.colors.black};
`
export const Label = styled.span`
  ${({ theme }) => theme.textStyles.m375_link}
  grid-column: 1 / span 1;
  grid-row: 1 / span 1;
  text-decoration: underline;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_link}
  }
`
export const LabelOn = styled(Label)`
  transition:
    opacity 0.3s ease-out,
    visibility 0s 0s;
  ${Toggle}[aria-expanded='true'] & {
    opacity: 0;
    visibility: hidden;
    transition:
      opacity 0.3s ease-out,
      visibility 0s 0.3s;
  }
`
export const LabelOff = styled(Label)`
  transition:
    opacity 0.3s ease-out,
    visibility 0s 0s;
  ${Toggle}:not([aria-expanded='true']) & {
    opacity: 0;
    visibility: hidden;
    transition:
      opacity 0.3s ease-out,
      visibility 0s 0.3s;
  }
`
export const Wrapper = styled.div<{ $height?: number }>`
  --accordion__height--content: ${({ $height }) =>
    $height ? `${$height}px` : pxToRem(250)};
  display: block;
  visibility: visible;
  opacity: 1;
  overflow: visible;
  max-height: var(--accordion__height--content);
  transition:
    max-height 0.3s ease-out,
    visibility 0s 0s;
  transform: translate3D(0, 0, 0);
  margin: unset;
  overflow: hidden;
  &[hidden] {
    display: block;
    visibility: hidden;
    max-height: 0;
    transition:
      max-height 0.3s ease-out,
      visibility 0s 0.3s;
  }
`
export const Content = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  width: 100%;
  height: auto;
  padding-block: ${pxToRem(0)} ${pxToRem(32)};
  transition: transform 0.3s ease-out;
  ${Wrapper}[hidden] & {
    transform: translateY(${pxToRem(-40)});
  }
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(40)};
  }
`
export const _RichText = styled(RichText)`
  ${({ theme }) => theme.textStyles.m375_body}
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(16)};
  padding-block-start: ${pxToRem(40)};
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_body}
    padding-inline-end: 0;
  }
`
